import { Button, Dialog, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import FileSaver from 'file-saver';
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import BillingService from '../../Services/billing/BillingService';
import ChecklistService from '../../Services/ChecklistService';
import Home from '../home/Home';
import Snacbar from '../Snacbar';
import { getDate, getPointId, getUserId } from '../Utils/Common';
import { ToggleButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const TitleColor = {
    color: 'red',
    fontWeight: 'bolder',
    fontFamily: 'Times New Roman',
}
const TitleColor1 = {
    color: 'red'
    , fontFamily: 'Times New Roman',
}
const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder'
    , fontFamily: 'Times New Roman',
}
const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
        color: 'black'
    },
}));
function CheckListSendParty() {
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    const [nonUplodedetails, setnonUplodedetails] = useState([]);
    const [Uplodedetails, setUplodedetails] = useState([]);
    const [ImporterDetails, setImporterDetails] = useState([]);
    const [JobTrackingDetails, setJobTrackingDetails] = useState([]);
    const [ChecklistAPPVERISUBMISSION, setChecklistAPPVERISUBMISSION] = useState([]);
    const [CustomerMailId, setCustomerMailId] = useState([]);

    const [consigmnt, setConsigment] = useState('');

    const [values, setValues] = useState({
        txt_customer: '',
        txt_mailSubject: 'SCOPE Service',
        txt_ClSendDate: getDate(),
        txt_MailContent: 'Dear Customer,Thank you for using our SCOPE service. Your Checklist Details successfully Prepared. And Here i Attached Your Checklist Copy',
        to_mail: '',
        to_mail_List: '',
        cc_mail: '',
        txt_jobNo: '',
        checklistcopyNo: ''
    })
    const [mailidValues, setMailIdValues] = useState({
        senderMailId: '', senderMailPwd: '', host: '', port: ''
    })
    const [Checklistcopy, setChecklistcopy] = useState('');
    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    })

    //OnChangeEvente
    const CustomerChangeHandle = (e) => {
        setValues({ ...values, txt_customer: e.target.value });
        getJobNoConsoleNonUpload(e.target.value, values.txt_jobNo);
    }

    const JobNoChangeHandle = (e) => {
        setValues({ ...values, txt_jobNo: e.target.value });
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') { consigmnt = '-1' }
        else { consigmnt = e.target.value }
        if (values.txt_customer === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = values.txt_customer; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '3' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }

    const SendDateChangeHandle = (e) => {
        setValues({ ...values, txt_ClSendDate: e.target.value });
    }

    const MailSubjectChangeHandle = (e) => {
        setValues({ ...values, txt_mailSubject: e.target.value });
    }

    const MailContentChangeHandle = (e) => {
        setValues({ ...values, txt_MailContent: e.target.value });
    }
    const ToMailIdChangeHandle = (e) => {
        setValues({ ...values, to_mail: e.target.value });
    }
    const ToMailIdListChangeHandle = (e) => {
        setValues({ ...values, to_mail_List: e.target.value, to_mail: values.to_mail + e.target.value + ',' });
    }
    const CCmailIdChangeHandle = (e) => {
        setValues({ ...values, cc_mail: e.target.value });
    }

    //getDatas
    const getDrpData = async () => {
        BillingService.getImporterDetails().then((res) => {
            setImporterDetails(res.data);
        })
    }

    const getJobNoConsoleNonUpload = (val, val2) => {
        var consigmnt, importer_iec_no = '';
        if (val2 === '') { consigmnt = '-1' }
        else { consigmnt = val2 }
        if (val === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = val; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '3' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }

    const getData = async () => {
        BillingService.getnonAudit('3').then((res) => { setnonUplodedetails(res.data); });
        BillingService.getAudit('3').then((res) => { setUplodedetails(res.data); });
    }

    const getsenderMailId = () => {
        ChecklistService.getsenderMailId(getUserId()).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            setMailIdValues({ ...mailidValues, host: lastResult[0].host, port: lastResult[0].port, senderMailId: lastResult[0].senderMailId, senderMailPwd: lastResult[0].senderMailPwd })
        })
    }

    useEffect(() => {
        getData(); getDrpData();
    }, []);

    const [selected, setSelected] = useState([]);
    //tableClick
    const editNonSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }

        setSelected(newSelected);

        setConsigment(item.consignmentNumber);
        BillingService.opgetConsignmentJobEntryAssign(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].senderAddress, txt_asTransitType: lastResult[0].transitTypeName,
                txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName, txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName,
                txt_asArrivalDate: lastResult[0].expectedArrivalDateTime, txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            });
        });

        ChecklistService.getChecklist(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setChecklistcopy('');
                setValues({ ...values, checklistcopyNo: '', txt_ClSendDate: getDate() });
            } else {
                setChecklistcopy(lastResult[0].checklistCopy);
                setValues({ ...values, checklistcopyNo: lastResult[0].checklistNo, txt_ClSendDate: getDate() });
            }
        });
        ChecklistService.getChecklistAPPVERISUBMISSION(item.consignmentNumber).then((res) => { setChecklistAPPVERISUBMISSION(res.data); })
        ChecklistService.getJobTrackingDetails(item.consignmentNumber).then((res) => {
            setJobTrackingDetails(res.data);
        })
        ChecklistService.getCustomerMailId(item.receiverMailId).then((res) => { setCustomerMailId(res.data); });
        getsenderMailId();
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;

    const editSumitedDetails = (item) => {

        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setConsigment(item.consignmentNumber);
        // BillingService.opgetConsignmentJobEntryAssign(item.consignmentNumber).then((res) => {
        BillingService.getJobDetailsAssign(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress, txt_asTransitType: lastResult[0].transitTypeName,
                txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName, txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName,
                txt_asArrivalDate: lastResult[0].expectedArrivalDateTime, txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            });
        });
        var cheacklistNo = '';
        ChecklistService.getChecklist(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setChecklistcopy('');
                cheacklistNo = '';
            } else {
                setChecklistcopy(lastResult[0].checklistCopy);
                cheacklistNo = lastResult[0].checklistNo;
            }
        });
        ChecklistService.getChecklistAPPVERISUBMISSION(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setValues({
                    ...values, txt_aprovalSts: '',
                    txt_aprovalDate: '', txt_aprovalRemarks: ''
                })
            } else {
                setValues({
                    ...values, checklistcopyNo: cheacklistNo, txt_aprovalSts: lastResult[0].approvalStatus,
                    txt_aprovalDate: lastResult[0].approvalDate, txt_aprovalRemarks: lastResult[0].approvalRemarks
                })
            }
            setChecklistAPPVERISUBMISSION(res.data);
        })
        ChecklistService.getJobTrackingDetails(item.consignmentNumber).then((res) => { setJobTrackingDetails(res.data); })
        ChecklistService.getCustomerMailId(item.receiverMailId).then((res) => { setCustomerMailId(res.data); });
        getsenderMailId();
    }
    const isAprvlSelected = (name) => selected.indexOf(name) !== -1;
    //ClickEvents


    const [saveDsa, setSaveDsa] = useState(false);
    const [processing, setprocessing] = useState(false)

    const DownlodCheacklist = () => {
        if (consigmnt !== '') {
            if (Checklistcopy === '' || !Checklistcopy) {
                setOpen(true); setSeverity('warning'); setMessage('CheckList Copy is Empty');
            } else {
                var file = b64toBlob(Checklistcopy, 'application/pdf')
                // var blob = new Blob(Checklistcopy, {type: "base64;charset=utf-8"});
                // setOpen(true);setSeverity('warning'); setMessage(Checklistcopy);
                // FileSaver.saveAs(Checklistcopy,values.checklistcopyNo+".pdf");
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file);
                }
                else {
                    var fileURL = URL.createObjectURL(file);
                    FileSaver.saveAs(fileURL, values.checklistcopyNo + ".pdf");
                }
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job.No From Job Tabel');
        }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    const validate = () => {
        if (values.to_mail !== '') {
            if (values.cc_mail !== '') {
                return true;
            } else {
                setOpen(true); setSeverity('warning'); setMessage('Kindly Enter The CC Mail Id..!');
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Kindly Enter The To Mail Id..!');
        }
        return false;
    }

    const update = () => {
        if (consigmnt !== '') {
            if (values.txt_ClSendDate !== '') {
                if (validate() === true) {
                    setSaveDsa(true); setprocessing(true);
                    let details = { consignmentId: consigmnt, sendDatetoImporter: values.txt_ClSendDate, createdBy: getUserId(), pointId: getPointId() }
                    ChecklistService.updateChecklistSendDate(details).then((res) => {
                        const message = res.data.message;
                        if (message.toString() === 'SUCCESS') {
                            sendMail(); setOpen(true); setSeverity('success'); setMessage(message);
                        } else {
                            setOpen(true); setSeverity('error'); setMessage('Update Failed ' + message); refresh();
                        }
                    }).catch((error) => {
                        setOpen(true); setSeverity('success'); setMessage('Update Failed ' + error.message); refresh();
                    });
                }
            } else {
                document.getElementById('approvalSts').focus();
                setOpen(true); setSeverity('warning'); setMessage('Please Enter a SendDate..!');
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Please Select Job.No From Job Tabel');
        }
    }
    const getPDF = () => {
        ChecklistService.getPDF(consigmnt).then((res) => {

        })
    }

    const sendMail = () => {
        getPDF();
        if (mailidValues.senderMailPwd !== '') {
            let details = {
                senderMailId: mailidValues.senderMailId, senderMailPassword: mailidValues.senderMailPwd, host: mailidValues.host, port: mailidValues.port,
                receiverMailId: values.to_mail, cc_receivermail_id: values.cc_mail, mailSubject: values.txt_mailSubject, text: values.txt_MailContent, consignmentId: consigmnt
            }
            ChecklistService.sendMail(details).then((res) => {
                refresh();
            }).catch((error) => {
                setOpen(true); setSeverity('success'); setMessage(error.message); refresh();
            });

        } else {
            setOpen(true); setSeverity('warning'); setMessage('No Sender MailId and Password, Based On Your Login')
        }
    }

    const search = () => {
        getJobNoConsoleNonUpload(values.txt_customer, values.txt_jobNo)
    }

    const refresh = () => {
        setSaveDsa(false); setprocessing(false);
        setConsigment('');
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '', txt_asClearancePort: '',
            txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: '', lbl_asAirlinesName: '', lbl_asHawbNo: ''
        });
        setChecklistcopy('');
        setChecklistAPPVERISUBMISSION([]); setJobTrackingDetails([]);
        setValues({
            ...values, checklistcopyNo: '', txt_ClSendDate: getDate(), cc_mail: '', to_mail: '', to_mail_List: '', txt_customer: '', txt_jobNo: '',
            txt_MailContent: 'Dear Customer,Thank you for using our SCOPE service. Your Checklist Details successfully Prepared. And Here i Attached Your Checklist Copy', txt_mailSubject: 'SCOPE Service',
        });
        getData();
    }


    //handleClose/open
    const handleClose = () => { setOpen(false); setSeverity(''); setMessage(''); }
    const [JobEntryOpen, setJobEntryOpen] = useState(false);
    const JobEntryOnCloseHandle = () => {
        setJobEntryOpen(false);
    }
    const JobEntryOpenHandle = () => {
        setJobEntryOpen(true);
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/checklistApprovalbMngr');
    }
    const ForwordBotton = () => {
        navigate('/checklistVerify');
    }
    return (
        <div>
            <Home /> <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            <div style={{ paddingLeft: '100px' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Dialog open={JobEntryOpen} onClose={JobEntryOnCloseHandle} fullWidth={true} maxWidth="lg">
                    <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}>
                        <center><lable>
                            Job Entry Details</lable></center>
                    </DialogTitle>
                    <ItemPap1>
                        <Row className='mt-1'>
                            <Col className='jobentrAssign' xs={4}>
                                <Row xs={5}>
                                    <Col xs={5}><label style={jobentrylablestyle}>Job.No</label></Col>
                                    <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asJobNo} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>MAWB No</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asMawbNo} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                    <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterName} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                    <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterCode} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                    <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterState} /></Col>
                                </Row>
                            </Col>

                            <Col className='jobentrAssign'>
                                <Row xs={5}>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                    <Col className='jobentrAssign'><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asTransitType} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Airlines Name</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asAirlinesName} /></Col>
                                </Row>
                            </Col>
                            <Col className='jobentrAssign'>
                                <Row xs={5}>
                                    <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginCountry} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginPort} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asClearancePort} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asArrivalDate} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>HAWB No</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asHawbNo} /></Col>
                                </Row>
                            </Col>
                        </Row>
                    </ItemPap1>
                </Dialog>
                <Grid container>
                    <Grid item xs={2}>
                        <ItemPap style={{ height: 428 }}>
                            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontSize: '13px', fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'red', marginLeft: '15px' }}>NonApproval Job</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {nonUplodedetails.map((item) => {
                                            const isItemSelected = isSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editNonSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                    <Grid item xs={8}>
                        <Grid container>
                            <ItemPap style={{ height: 428 }}>
                                <div className='form-inline mt-2 mb-2 p-1'>
                                    <Row>
                                        <center className='mb-3'><lable style={{ fontSize: '25px', fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'red', marginBottom: '2%' }}>CHECKLIST SEND TO CUSTOMER</lable></center>
                                        <Col></Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label style={{ color: 'darkblue', fontFamily: 'Times New Roman', fontWeight: 'bolder' }}>Customer</Form.Label>
                                        </Col>
                                        <Col xs={3}>
                                            <Form.Select style={{ border: '1px solid black', fontFamily: 'Times New Roman', fontWeight: 'bold', height: '26px' }} size='sm' value={values.txt_customer} onChange={CustomerChangeHandle}>
                                                <option value=''></option>
                                                {ImporterDetails.map((item) => (
                                                    <option key={item.serialNumber} value={item.importer_iec_no}>{item.importer_name}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label style={{ color: 'darkblue', fontFamily: 'Times New Roman', fontWeight: 'bolder' }}>Job.No</Form.Label>
                                        </Col>
                                        <Col xs={2}>
                                            <Form.Control style={{ border: '1px solid black', fontFamily: 'Times New Roman', fontWeight: 'bold', height: '26px', textAlign: 'center' }} value={values.txt_jobNo} onChange={JobNoChangeHandle} />
                                        </Col>
                                        <Col>
                                            <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} size='small' onClick={search}>search</Button>
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                </div>
                                <Row className='mt-3'>
                                    <Col></Col>
                                    <Col xs={2}>
                                        <Form.Label style={TitleColor}>CL_Send_Date</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control type='date' style={{ border: '1px solid black', fontWeight: 'bold', height: '26px' }} className='cntrtxt' value={values.txt_ClSendDate} required onChange={SendDateChangeHandle} />
                                    </Col>
                                    <Col xs={2}>
                                        <Form.Label className='billingIpTitle'>MailSubject</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control style={{ border: '1px solid black', fontWeight: 'bold', height: '26px' }} className='cntrtxt' value={values.txt_mailSubject} onChange={MailSubjectChangeHandle} />
                                    </Col>
                                    <Col></Col>

                                </Row>
                                <Row className='mt-1'>
                                    <Col></Col>

                                    <Col xs={2}>
                                        <Form.Label className='billingIpTitle'>MailContent</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control style={{ fontWeight: 'bold', border: '1px solid black' }} as='textarea' rows='3' className='cntrtxt' value={values.txt_MailContent} onChange={MailContentChangeHandle} />
                                    </Col>
                                    <Col xs={5}>
                                        <Form.Label style={TitleColor1}>Mail Id Format</Form.Label>
                                        <Form.Label style={TitleColor1}>1st Mail,2nd Mail,3rd Mail,etc..</Form.Label>
                                    </Col>
                                    <Col></Col>
                                </Row>
                                <Row className='mt-1'>
                                    <Col></Col>
                                    <Col xs={2}>
                                        <Form.Label style={TitleColor}>To Mail Id</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control style={{ border: '1px solid black', fontWeight: 'bold', height: '26px' }} className='cntrtxt' value={values.to_mail} onChange={ToMailIdChangeHandle} required />
                                    </Col>
                                    <Col xs={2}>
                                        <Form.Label style={TitleColor}>To_Mail_Id_List</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select sixe='sm' style={{ border: '1px solid black', fontWeight: 'bold', height: '26px' }} className='cntrtxt' value={values.to_mail_List} onChange={ToMailIdListChangeHandle}>
                                            <option value=''></option>
                                            {CustomerMailId.map((item) => (
                                                <option value={item.receiverMailId}>{item.receiverMailId}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col></Col>
                                </Row>
                                <Row className='mt-2'>
                                    <Col></Col>
                                    <Col xs={2}>
                                        <Form.Label style={TitleColor}>CC Mail Id</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control style={{ textAlign: 'center', fontFamily: 'Times New Roman', border: '1px solid black', fontWeight: 'bold', height: '26px' }} value={values.cc_mail} onChange={CCmailIdChangeHandle} required />
                                    </Col>
                                    <Col xs={2}></Col>
                                    <Col xs={3}></Col>
                                    <Col></Col>

                                </Row>
                                <center><div className='mt-2'>
                                    <Button variant='contained' className='mt-1'color='success' size='small' onClick={DownlodCheacklist}>Download Checklist Copy</Button>{' '}
                                    <Button variant='contained' className='mt-1'color='primary' size='small' disabled={saveDsa} onClick={update}>{processing ? 'processing' : 'Send Mail To Importer'}</Button>{' '}
                                    <Button variant='contained' className='mt-1'color='warning' size='small' onClick={refresh}>Refresh</Button>{' '}
                                    <Button variant='contained' className='mt-1'color='primary' size='small' onClick={JobEntryOpenHandle}>Open Job Entry Details</Button>
                                </div></center>
                            </ItemPap>
                        </Grid>
                    </Grid>
                    <Grid item xs={2}>
                        <ItemPap2 style={{ height: 428 }}>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red', marginRight: '30px' }}>Approval Job</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Uplodedetails.map((item) => {
                                            const isItemSelected = isAprvlSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} selected={isItemSelected} tabIndex={-1} onClick={() => editSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap2>
                    </Grid>
                    <Grid item xs={6} >
                        <ItemPap>
                            <TableContainer sx={{ height: 204 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>JobNo</StyledTableCell>
                                            <StyledTableCell align='center'>CheclistNo</StyledTableCell>
                                            <StyledTableCell align='center'>ClApprovalSts</StyledTableCell>
                                            <StyledTableCell align='center'>ClApprovalDate</StyledTableCell>
                                            <StyledTableCell align='center'>ClApprovalRemarks</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ChecklistAPPVERISUBMISSION.map((item) => (
                                            <TableRow hover key={item.consignmentId} >
                                                <StyledTableCell align='center'>{item.consignmentId}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.checklistNo}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalStatus}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalDate}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalRemarks}</StyledTableCell>
                                            </TableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                    <Grid item xs={6}>
                        <ItemPap>
                            <center><lable style={{ fontSize: '16px', fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'red' }}>Job Tracking Details</lable></center>
                            <TableContainer sx={{ height: 180 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Operation Location</StyledTableCell>
                                            <StyledTableCell align='center'>Operation Date</StyledTableCell>
                                            <StyledTableCell align='center'>Operation Status</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {JobTrackingDetails.map((item) => (
                                            <TableRow hover key={item.serialNumber} >
                                                <StyledTableCell align='center'>{item.userLocation}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.operationDate}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.operationStatus}</StyledTableCell>
                                            </TableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                </Grid>
            </div>
        </div >
    )
}

export default CheckListSendParty